import { z } from 'zod';

export const appSchemes = z.enum([
  'hive',
  'hive-canary',
  'hive-beta',
  'hive-internal',
  'hive-dev',
]);

const appChannelSchemes = z.enum(['stable', 'canary', 'beta', 'internal']);

export type Scheme = z.infer<typeof appSchemes>;
export type Channel = z.infer<typeof appChannelSchemes>;

export const schemeToChannel = {
  hive: 'stable',
  'hive-canary': 'stable',
  'hive-beta': 'stable',
  'hive-internal': 'stable',
  'hive-dev': 'stable', // dev does not have a dedicated app. use canary as the placeholder.
  // 'hive-canary': 'canary',
  // 'hive-beta': 'beta',
  // 'hive-internal': 'internal',
  // 'hive-dev': 'canary', // dev does not have a dedicated app. use canary as the placeholder.
} as Record<Scheme, Channel>;

export const channelToScheme = {
  stable: 'hive',
  canary: BUILD_CONFIG.debug ? 'hive-dev' : 'hive-canary',
  beta: 'hive-beta',
  internal: 'hive-internal',
} as Record<Channel, Scheme>;

export const appIconMap = {
  stable: '/imgs/app-icon-stable.ico',
  canary: '/imgs/app-icon-stable.ico',
  beta: '/imgs/app-icon-stable.ico',
  internal: '/imgs/app-icon-stable.ico',
  // canary: '/imgs/app-icon-canary.ico',
  // beta: '/imgs/app-icon-beta.ico',
  // internal: '/imgs/app-icon-internal.ico',
} satisfies Record<Channel, string>;

export const appNames = {
  stable: 'Hive',
  canary: 'Hive',
  beta: 'Hive',
  internal: 'Hive',
  // canary: 'Hive Canary',
  // beta: 'Hive Beta',
  // internal: 'Hive Internal',
} satisfies Record<Channel, string>;

export const appSchemaUrl = z.custom<string>(
  (url: string) => {
    try {
      return appSchemes.safeParse(new URL(url).protocol.replace(':', ''))
        .success;
    } catch {
      return false;
    }
  },
  { message: 'Invalid URL or protocol' }
);
